import React from "react";
import { useNavigate } from "react-router-dom";

export default function VaultEmptyState({
    title = "No Vault Access Available",
    description = "We’re sorry, there are currently no items available based on your selection.",
    showButton = false
}) {
    const navigate = useNavigate();

    return (
        <section className="vault-empty-state">
            <div className="container text-center">
                <div className="vault-empty-wrapper">
                    <img
                        src="/assets/images/vaultaccess/noStock.png"
                        alt="No Vault Access"
                        className="vault-empty-image"
                    />

                    <h2 className="mt-4 fw-bold">{title}</h2>

                    <p className="text-muted mt-2">
                        {description}
                    </p>

                    {showButton && (
                        <button
                            className="btn btn-primary mt-3 px-4"
                            onClick={() => navigate("/vault-access")}
                        >
                            Go to Vault Access
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
}
